export const BASE_URL = 'https://api.viabus.io';
export const URL = process.env.VUE_APP_API_URL;
